export default __webpack_public_path__ + "static/media/APYS-BNB.03331786.svg";